import React, { ReactNode } from 'react';
import './modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  hideClose?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, hideClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{display:'flex', alignItems:'flex-end'}}>
      <div className="modal-container" style={{width:'100%'}}>
        {!hideClose && (
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
